import { FormatMoney } from '../../../../hooks/useMoney';
import { Locales } from '../../../../modules/translation/messages';
import { NumberRangeFilterTypes } from './numberRangeFilter.types';

export const formatNumberLabel = (
  type: NumberRangeFilterTypes,
  value: number,
  formatMoney: FormatMoney,
  locale: Locales,
) => {
  if (type === NumberRangeFilterTypes.MONETARY) {
    return formatMoney(value);
  }

  if (type === NumberRangeFilterTypes.PERCENTAGE) {
    return `${value}%`;
  }

  if (type === NumberRangeFilterTypes.INTEGER) {
    return value.toLocaleString(locale);
  }

  return value;
};
